/**
 * order_id после оплаты: query (?order_id=) или start_param / startapp (Max, Telegram).
 *
 * start_param живёт всю сессию Mini App — без consume при каждом remount
 * снова редиректит на /orders и открывает модалку («Заказ не найден» по кругу).
 */

const CONSUMED_STORAGE_KEY = "forel:postPaymentOrderId:consumed";

/** Fallback если sessionStorage недоступен (private mode). */
const consumedMemory = new Set<string>();

function readStartParam(): string | null {
  const maxStart = window.WebApp?.initDataUnsafe?.start_param;
  if (typeof maxStart === "string" && maxStart.trim() !== "") {
    return maxStart.trim();
  }

  const tgStart = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
  if (typeof tgStart === "string" && tgStart.trim() !== "") {
    return tgStart.trim();
  }

  return null;
}

function peekPostPaymentOrderId(): string | null {
  if (typeof window === "undefined") return null;

  const fromQuery = new URLSearchParams(window.location.search)
    .get("order_id")
    ?.trim();
  if (fromQuery) return fromQuery;

  return readStartParam();
}

function wasConsumed(orderId: string): boolean {
  if (consumedMemory.has(orderId)) return true;
  try {
    return sessionStorage.getItem(CONSUMED_STORAGE_KEY) === orderId;
  } catch {
    return false;
  }
}

function markConsumed(orderId: string): void {
  consumedMemory.add(orderId);
  try {
    sessionStorage.setItem(CONSUMED_STORAGE_KEY, orderId);
  } catch {
    /* private mode / blocked storage */
  }
}

/**
 * Вернуть order_id для post-payment редиректа и пометить его обработанным.
 * Повторный вызов с тем же id (типичный remount + живой start_param) → null.
 */
export function consumePostPaymentOrderId(): string | null {
  const orderId = peekPostPaymentOrderId();
  if (!orderId) return null;
  if (wasConsumed(orderId)) return null;
  markConsumed(orderId);
  return orderId;
}

/** Текущий order_id из URL / start_param без consume (отладка). */
export function resolvePostPaymentOrderId(): string | null {
  return peekPostPaymentOrderId();
}
